import React from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { useTranslation } from '@zauberware/react-i18n/web'
import { Breadcrumb as AntBreadcrumb } from 'antd'
import { FilterPortal } from '../../atoms'
import useBreadcrumbQueries from './useBreadcrumbQueries'
import './Breadcrumbs.scss'

const Breadcrumbs = () => {
  const { t } = useTranslation('common')
  const params = useParams()
  const location = useLocation()
  const path = location.pathname

  const crumbs = useBreadcrumbQueries(path, params)

  const populateBreadcrumbs = () => {
    const sections = path.split('/').slice(2)
    const subPaths = path.split('/')
    return sections.map((section, index) => {
      let name = section
      let clickable = index === 0

      // Check if this section matches a route param (is a dynamic ID)
      if (section === params?.id && crumbs.id) {
        name = crumbs.id
        clickable = true
      } else if (section === params?.inquiryId && crumbs.inquiryId) {
        name = crumbs.inquiryId
        clickable = true
      } else if (section === params?.customerId && crumbs.customerId) {
        name = crumbs.customerId
        clickable = true
      }

      const href = subPaths.slice(0, index + 3).join('/')
      return { name, href, clickable }
    })
  }

  const renderElement = (item, index) => (
    <AntBreadcrumb.Item
      key={index}
      style={!item.clickable ? { cursor: 'default', color: '#000' } : { color: '#000' }}
      href={item.clickable ? item.href : undefined}
    >
      {t(item.name)}
    </AntBreadcrumb.Item>
  )

  return (
    <FilterPortal>
      <AntBreadcrumb
        className="breadcrumb-nav"
        separator=">"
        style={{
          fontSize: '1.75rem',
          fontWeight: 500
        }}
      >
        {populateBreadcrumbs()?.map(renderElement)}
      </AntBreadcrumb>
    </FilterPortal>
  )
}

export default Breadcrumbs
